import React, { useEffect, useState } from "react";
import DTOFeedback from "./DTOFeedback";
import FeedbackPresenter from "./FeedbackPresenter";

import { useTranslation } from "react-i18next";
function FeedbackController() {
  const { t } = useTranslation();

  return (
    <div>
      <DTOFeedback />
      <FeedbackPresenter trans={t} />
    </div>
  );
}

export default FeedbackController;
